export default {
    cms: {
        endpoint: 'https://cms.staging.gladwellacademy.com/graphql'
    },
    api: {
        endpoint: 'https://api.staging.gladwellacademy.com'
    }
};
